import React, { Component } from 'react';
import styled from 'styled-components';
import { bool, func, string, object } from 'prop-types';

import Input from 'library/components/form-elements/input';
import Dropdown from 'apps/journey/components/dropdown/dropdown';
import { resolve } from 'library/helpers/path-resolver';
import withProfileFieldData from 'apps/journey/hoc/with-profile-field-data';
import InfoTooltip from 'apps/journey/components/info-tooltip';

const StyledContainer = styled.div`
  margin-bottom: 1em;
`;

const StyledRow = styled.div`
  display: flex;
  > * {
    &:first-child {
      flex: 1;
    }
  }
`;

class ProfilePhone extends Component {
  static propTypes = {
    label: string,
    onChange: func,
    name: string,
    loadFromContext: bool,
    question: object,
    tooltip: string,
  };

  constructor(props) {
    super(props);
  }

  state = {
    ignore: false,
    phone_data: {},
  };

  static getDerivedStateFromProps = (props, state) => {
    if (!state.ignore && props.question) {
      return {
        phone_data: JSON.parse(
          resolve(props.question, 'user_response/string_response', '{}')
        ),
        ignore: true,
      };
    }
    return null;
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    if (
      nextProps.question !== this.props.question ||
      nextState.phone_data !== this.state.phone_data
    ) {
      return true;
    }
    return false;
  };

  handleOnChange = ({ target }) => {
    const { name, value, key, nodeName = 'INPUT' } = target;
    this.setState({ loading: true });

    const answer = {
      ...this.state.phone_data,
      [name]: value,
    };

    try {
      this.props.onChange({
        target: {
          id: resolve(this.props.question, 'id', null),
          answer: answer,
        },
      });
      this.setState({
        phone_data: answer,
        loading: false,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        loading: false,
      });
    }
  };

  render() {
    const pvalue = resolve(this.state.phone_data, 'phone_number', '');
    const tvalue = resolve(this.state.phone_data, 'number_type', '');

    const { question, tooltip } = this.props;

    return (
      <StyledContainer>
        <StyledRow>
          <Input
            onChange={this.handleOnChange}
            aria-label="Enter a 10 digit phone number"
            pattern="([0-9]{3}(\.|-|\s){1}[0-9]{3}(\.|-|\s){1}[0-9]{4})|([0-9]{10})"
            name="phone_number"
            label="Phone Number (111-111-1111)"
            type="tel"
            value={pvalue}
            delayInput={true}
          />
          {tooltip && (
            <InfoTooltip
              key={question.id}
              tooltip={tooltip}
              uid={question.id}
              iconOnly
            />
          )}
        </StyledRow>
        <Dropdown
          onChange={this.handleOnChange}
          label={'Phone Type'}
          aria-label="Select a phone number type"
          name="number_type"
          value={tvalue}
          options={[
            {
              key: 'home',
              value: 'Home',
            },
            {
              key: 'mobile',
              value: 'Mobile',
            },
            {
              key: 'work',
              value: 'Work',
            },
          ]}
        />
      </StyledContainer>
    );
  }
}

export default withProfileFieldData(ProfilePhone);
